import React from "react"
import { StateMachineProvider, useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { journeySteps, journeyWorkflows } from "./workflow"
import { JourneyFlowContainer } from "../../shared/JourneyFlowContainer"

function JourneyFlowView(): JSX.Element {
  const { step } = useStateMachine()
  return React.createElement(step.view)
}

export default function JourneyFlow(): JSX.Element {
  const stateMachineProps = {
    initialStep: Steps.WHAT_KIND_OF_JOURNEY,
    workflows: journeyWorkflows,
    steps: journeySteps,
    stateMachineName: "Journey",
    workflowName: "Journey"
  }
  return (
    <StateMachineProvider {...stateMachineProps} handleWorkflowComplete={null}>
      <JourneyFlowContainer>
        <JourneyFlowView />
      </JourneyFlowContainer>
    </StateMachineProvider>
  )
}
